import React, { useEffect } from 'react';

import { setLoading } from '../../redux/loading/loadingActions';
import { certificatesActions, certificatesList } from '../../redux/reducers/certificates';
import { showError } from '../../elements/Toasts/toastActions';

import strings from '../../lang/lang';
import settings from '../../pages/apps/Settings.module.scss';
import styles from '../Profile/Profile.module.scss';
import { useAppSelector, useAppDispatch } from '../../hooks/useRedux';

import CertificateList from './CertificateList';
import CertificateGenerate from './CertificateGenerate';
import CertificateUpload from './CertificateUpload';
import Modals from './Modals/ModalsContainer';


function CertificateContainer() {
  const isProdSwitcherOpen = useAppSelector((state) => state.prodSwitcher.isProdSwitcherOpen);
  const certificates = useAppSelector(certificatesList);
  const dispatch = useAppDispatch();

  useEffect(() => {
    loadCertificatesList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProdSwitcherOpen]);

  function loadCertificatesList() {
    return new Promise((res, rej) => {
      setLoading(true);
      dispatch(certificatesActions.loadCertificates({ res, rej }));
    })
    .catch(() => {
      showError(strings.certificateContainer.errors.retrievingException);
    })
    .finally(() => {
      setLoading(false);
    });
  }

  return (
    <div className={styles.profile}>
      <h1 className={styles.profile__title}>Certificates</h1>
      <CertificateGenerate />
      <CertificateUpload
        onClick={() => dispatch(certificatesActions.setActiveModalDetails({ name: 'upload CSR file' }))}
      />
      {certificates && certificates.length === 0 ? (
        <div className={settings.settings__no_certificate}>
          {strings.certificateContainer.text.noCertificates}
        </div>
      ) : (
        <CertificateList
          // header={strings.certificateContainer.text.downloadTitle}
          openModal={(value) => dispatch(certificatesActions.setActiveModalDetails(value))}
          certificates={certificates}
        />
      )}
      <Modals />
    </div>
);
}


export default CertificateContainer;
